import { render } from "./customer-report.vue?vue&type=template&id=1cee2420"
import script from "./customer-report.vue?vue&type=script&lang=js"
export * from "./customer-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__